import { render, staticRenderFns } from "./ResourceScheduleList.vue?vue&type=template&id=6d78d9e8&scoped=true"
import script from "./ResourceScheduleList.vue?vue&type=script&lang=js"
export * from "./ResourceScheduleList.vue?vue&type=script&lang=js"
import style0 from "./ResourceScheduleList.vue?vue&type=style&index=0&id=6d78d9e8&prod&lang=scss"
import style1 from "./ResourceScheduleList.vue?vue&type=style&index=1&id=6d78d9e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d78d9e8",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QSpinner});
